import PropTypes from 'prop-types'
import { Alert, Box, Button, Typography, IconButton } from '@mui/material'
import useTranslations from '../../../i18n/useTranslations'
import useIsMobile from '../../../hooks/useIsMobile'
import ModalLayout from '../layout'
import Clock from '../../../assets/animations/clock'
import Countdown, { zeroPad } from 'react-countdown'
import { ReactComponent as X } from '../../../assets/icons/x.svg'
import { ReactComponent as ArrowRight } from '../../../assets/icons/arrow-right.svg'
import { ReactComponent as ClockCountdown } from '../../../assets/icons/clockCountdown.svg'

import useStyles from './styles'

const SessionExpirationModal = ({
  isOpen,
  onContinue = () => {},
  onCompleted = () => {},
  time,
}) => {
  const t = useTranslations()
  const isMobile = useIsMobile()
  const classes = useStyles(time)

  const renderer = ({ minutes, seconds, completed }) => {
    if (completed) {
      onCompleted()
      return null
    }

    return (
      <Box className={classes.counter}>
        {zeroPad(minutes)}:{zeroPad(seconds)}
      </Box>
    )
  }

  const Header = ({ time }) => (
    <Box className={classes.header}>
      <Clock width={isMobile ? '100%' : 400} height={isMobile ? 170 : 200} />
      <ClockCountdown className={classes.clock} time={time} />
      <Countdown date={Date.now() + time} renderer={renderer} />
      {isMobile ? (
        <IconButton onClick={onContinue} className={classes.closeButton}>
          <X color="neutral.main" />
        </IconButton>
      ) : null}
    </Box>
  )

  const CustomAlert = () => (
    <Alert severity="warning" className={classes.alert}>
      <Typography>{t('session:make-sure-completed-request')}</Typography>
    </Alert>
  )

  const CustomButton = () => (
    <Button
      type="button"
      onClick={onContinue}
      size={isMobile ? 'medium' : 'small'}
      endIcon={<ArrowRight />}
      fullWidth
    >
      {t('session:continue')}
    </Button>
  )

  return (
    <ModalLayout
      header={<Header time={time} />}
      title={t('session:about-to-expire')}
      content={t('session:protect-data')}
      extraContent={<CustomAlert />}
      actions={<CustomButton />}
      isOpen={isOpen}
      anchor="bottom"
    />
  )
}

SessionExpirationModal.propTypes = {
  isOpen: PropTypes.bool,
  time: PropTypes.number.isRequired,
  onContinue: PropTypes.func.isRequired,
  onCompleted: PropTypes.func.isRequired,
}

export default SessionExpirationModal
